{
  "eyebrow": "Scegli il tuo piano",
  "title": "Il piano giusto per il tuo team.",
  "sub": "30 giorni di prova gratuita su ogni piano. Niente carta di credito. Annulla quando vuoi.",
  "bill": {
    "month": "Mensile",
    "year": "Annuale",
    "save": "Risparmia 15%"
  },
  "fam": {
    "time": "Tempo e operazioni",
    "project": "Progetti e controllo dei costi"
  },
  "compare": "Confronta tutte le funzioni",
  "compareHide": "Nascondi confronto",
  "included": "Incluso",
  "select": "Scegli {{plan}}",
  "selected": "Selezionato",
  "recommended": "Più popolare",
  "pricePerMonth": "/ utente / mese",
  "pricePerYear": "/ utente / anno",
  "base": "base / mese",
  "admins": "2 amministratori inclusi",
  "continueCta": "Continua con {{plan}}",
  "continuePick": "Scegli un piano per continuare",
  "catalogError": "Catalogo prezzi non disponibile. Riprova per caricare i prezzi più recenti.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Conformità e rilevamento semplice",
    "timeProBest": "Operazioni di team",
    "projectBasicBest": "Progetti e controllo dei costi",
    "projectProBest": "Gestione progetti avanzata",
    "feat": {
      "timeBasic": {
        "timeTracking": "Registrazione del tempo",
        "absencesHolidays": "Assenze e ferie",
        "transport": "Registri di trasporto",
        "workLocations": "Luoghi di lavoro e GPS",
        "mobileApp": "App mobile per i lavoratori sul campo"
      },
      "timePro": {
        "everythingTime": "Tutto di Time Basic",
        "overtime": "Registrazione degli straordinari",
        "scheduling": "Pianificazione dei turni",
        "documents": "Documenti dei dipendenti",
        "officeOps": "Funzioni d'ufficio (log attività, correzioni)",
        "addonsAvailable": "Add-on disponibili: gestione progetti, VTT",
        "internalMessaging": "Messaggistica interna (chat aziendale)"
      },
      "projectBasic": {
        "everythingTime": "Tutto di Time Basic",
        "projects": "Progetti con controllo dei costi",
        "extras": "Lavoro e materiale extra",
        "subcontractors": "Gestione subappaltatori",
        "checkInOut": "Check-in / check-out dei lavoratori",
        "internalMessaging": "Messaggistica interna (chat aziendale)"
      },
      "projectPro": {
        "everythingAll": "Tutto di Time Pro + Project Basic",
        "projectTransport": "Trasporto per progetto",
        "fullSuite": "Suite completa di produttività",
        "prioritySupport": "Assistenza prioritaria",
        "internalMessaging": "Messaggistica interna (chat aziendale)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Confronta tutte le funzionalità",
    "subtitle": "Tutto ciò che include ogni piano, fianco a fianco.",
    "cat": {
      "timeAttendance": "Tempo & presenze",
      "projectCost": "Progetto & controllo dei costi",
      "support": "Assistenza"
    },
    "val": {
      "upTo4": "Fino a 4",
      "unlimited": "Illimitato",
      "soon": "Presto",
      "optional": "Opzionale",
      "years5": "5 anni",
      "years10": "10 anni"
    },
    "row": {
      "mobileDesktop": "App mobile e desktop",
      "gpsCheckin": "Timbratura con un tocco tramite GPS",
      "holidayAbsenceOvertime": "Ferie, assenze e straordinari",
      "teamMembers": "Membri del team",
      "workLocations": "Sedi di lavoro",
      "registrationsPerMonth": "Registrazioni / utente / mese",
      "irregularMap": "Timbratura irregolare sulla mappa",
      "expenseManagement": "Gestione delle spese",
      "employeeDocuments": "Documenti dei dipendenti",
      "openApi": "API aperta",
      "navigation": "Navigazione verso i cantieri",
      "projectManagement": "Gestione progetti (budget)",
      "subprojects": "Sottoprogetti",
      "subcontractorManagement": "Gestione dei subappaltatori",
      "extraWorkMaterials": "Lavori e materiali extra",
      "transportProjects": "Trasporto collegato ai progetti",
      "fullSuite": "Suite di produttività completa",
      "prioritySupport": "Assistenza prioritaria",
      "languages12": "Disponibile in 12 lingue",
      "manualTransport": "Distanza di trasporto manuale",
      "reportsExcel": "Report ed esportazione Excel",
      "frontendLocations": "Sedi create dagli utenti dell'app",
      "checkInWork": "Check-in/out@work (Belgio)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Descrizioni e foto dei progetti",
      "dataStorage": "Archiviazione dei dati",
      "schedulingPlanning": "Pianificazione",
      "messagingNotifications": "Messaggi · Notifiche"
    }
  }
}
